var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"out-div"},[_c('div',{staticClass:"card-top"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_c('div',{ref:"jsmind_container",attrs:{"id":"jsmind_container"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }